module.exports = __webpack_public_path__ + "img/stage_thumb.ccb63d67.jpg";